import {
  getDataMapFromCommonResponse,
  isCommonResponseSuccessfulV2,
  logoutHandlerMentor,
} from '../helpers/utilityFunctions'
import { getMPDataWithoutParams } from '../services'
import { MENTOR_ONBOARDING_TYPES } from 'src/consumer/constants'
import { getCPDataWithoutParams } from 'src/clinic/services'

export function getUserRoles() {
  try {
    const role = localStorage.getItem('authorities')
    return JSON.parse(role)
  } catch (error) {
    logoutHandlerMentor()
    window.location.reload()
  }
}

export function getIsTeacherOrCreatorData() {
  const role = getUserRoles()
  const isTeacher = role?.includes('ROLE_TEACHER')
  const isCreator = role?.includes('ROLE_CREATOR')
  return { isTeacher, isCreator }
}

export function getAllRolesInBoolean() {
  try {
    const role = getUserRoles()
    const isNormalUser = role?.includes('ROLE_USER')
    const isProfessionalUser = role?.includes('ROLE_PROFESSIONAL_USER')
    const isPatient = role?.includes('ROLE_PATIENT')
    const isPatientProspect = role?.includes('ROLE_PATIENT_PROSPECT')
    const isCreator = role?.includes('ROLE_CREATOR')
    const isTeacher = role?.includes('ROLE_TEACHER')
    const isDoctor = role?.includes('ROLE_DOCTOR')
    const isTherapist = role?.includes('ROLE_THERAPIST')
    const isScreener = role?.includes('ROLE_SCREENER')
    const isBusinessProspect = role?.includes('ROLE_BUSINESS_PROSPECT')
    const isBusinessCustomer = role?.includes('ROLE_BUSINESS_CUSTOMER')
    const isAdmin = role?.includes('ROLE_ADMIN')
    const isDeveloper = role?.includes('ROLE_DEVELOPER')
    const isAppManager = role?.includes('ROLE_APP_MANAGER')
    const isClinicProspect = role?.includes('ROLE_CLINIC_PROSPECT')
    const isClinicAssistant = role?.includes('ROLE_CLINIC_ASSISTANT')
    const isClinicAdmin = role?.includes('ROLE_CLINIC_ADMIN')
    const isClinicManager = role?.includes('ROLE_CLINIC_MANAGER')
    const isClinicOwner = role?.includes('ROLE_CLINIC_OWNER')
    const isPharmacist = role?.includes('ROLE_PHARMACIST')
    const isChamberScreen = role?.includes('ROLE_CHAMBER_SCREEN')
    const isL1TherapySupport = role?.includes('ROLE_THERAPY_SUP_L1')
    const isL2TherapySupport = role?.includes('ROLE_THERAPY_SUP_L2')
    const isL3TherapySupport = role?.includes('ROLE_THERAPY_SUP_L3')
    const isTherapistAdmin = role?.includes('ROLE_THERAPIST_ADMIN')
    const isClinicRosterManager = role?.includes('ROLE_CLINIC_ROSTER_MANAGER')
    const isClinicRosterAdmin = role?.includes('ROLE_CLINIC_ROSTER_ADMIN')
    const isReadOnlyRescricted = role?.includes('ROLE_READ_ONLY_RESTRICTED')
    const isClinicSuccessManager = role?.includes('ROLE_CLINIC_SUCCESS_MANAGER')
    const isClinicSuccessAdmin = role?.includes('ROLE_CLINIC_SUCCESS_ADMIN')
    const isScreenerSupervisor = role?.includes('ROLE_SCREENER_SUPERVISOR')
    const isScreenerAdmin = role?.includes('ROLE_SCREENER_ADMIN')
    const isTherapistSupervisor = role?.includes('ROLE_THERAPIST_SUPERVISOR')
    const isTherapySupervisor = role?.includes('ROLE_THERAPY_SUPERVISOR')
    const isAumhumScreen = role?.includes('ROLE_AUMHUM_SCREEN')
    const isKiosk = role?.includes('ROLE_KIOSK')
    const isOoh = role?.includes('ROLE_OOH')
    const isSupport = role?.includes('ROLE_SUPPORT')
    const isSupportUser = role?.includes('ROLE_SUPPORT_USER')
    const isPaymentSupport = role?.includes('ROLE_PAYMENT_SUPPORT')
    const isManagement = role?.includes('ROLE_MANAGEMENT')
    const isVcAuditAdmin = role?.includes('ROLE_VC_AUDIT_ADMIN')
    const isVcAuditManager = role?.includes('ROLE_VC_AUDIT_MANAGER')
    const isDocSideAdmin = role?.includes('ROLE_DOCSIDE_ADMIN')
    const isDocSideManager = role?.includes('ROLE_DOCSIDE_MANAGER')

    return {
      isTeacher,
      isCreator,
      isDoctor,
      isTherapist,
      isScreener,
      isPatient,
      isPatientProspect,
      isBusinessCustomer,
      isNormalUser,
      isProfessionalUser,
      isAdmin,
      isDeveloper,
      isAppManager,
      isBusinessProspect,
      isClinicProspect,
      isClinicAssistant,
      isClinicAdmin,
      isClinicManager,
      isClinicOwner,
      isPharmacist,
      isChamberScreen,
      isL1TherapySupport,
      isL2TherapySupport,
      isL3TherapySupport,
      isTherapistAdmin,
      isClinicRosterManager,
      isClinicRosterAdmin,
      isReadOnlyRescricted,
      isClinicSuccessManager,
      isClinicSuccessAdmin,
      isScreenerSupervisor,
      isScreenerAdmin,
      isTherapistSupervisor,
      isTherapySupervisor,
      isAumhumScreen,
      isKiosk,
      isOoh,
      isSupport,
      isSupportUser,
      isPaymentSupport,
      isManagement,
      isVcAuditAdmin,
      isVcAuditManager,
      isDocSideAdmin,
      isDocSideManager,
    }
  } catch (error) {
    logoutHandlerMentor()
    window.location.reload()
  }
}

// Whether the current SUPPORT-portal user may manage (upload report / mark completed) a session of the given
// event type. Mirrors the backend authorization in SupportEmrReportsController / BookedEventsSupportController so
// we only show the action to roles that can actually perform it. Not relevant to the mentor (practitioner) portal,
// where the practitioner acts on their own sessions.
export function canSupportManageSessionForEventType(eventType) {
  const roles = getAllRolesInBoolean() || {}
  switch (eventType) {
    case 'screening':
    case 'screening-report':
      return Boolean(roles.isL3TherapySupport || roles.isScreenerSupervisor)
    case 'therapy-session':
    case 'therapy':
    case 'therapy-report':
      return Boolean(
        roles.isL3TherapySupport || roles.isTherapistSupervisor || roles.isTherapySupervisor,
      )
    case 'assessment':
    case 'assessment-report':
      return Boolean(roles.isL3TherapySupport || roles.isTherapySupervisor)
    case 'investigation':
    case 'investigation-report':
      return Boolean(
        roles.isL3TherapySupport || roles.isTherapySupervisor || roles.isScreenerSupervisor,
      )
    case 'consultation':
      return Boolean(
        roles.isL3TherapySupport || roles.isClinicSuccessManager || roles.isClinicSuccessAdmin,
      )
    default:
      return false
  }
}

export const ALL_SUPPORTED_ROLES_FOR_FLOW_SELECTION = [
  'ROLE_USER',
  'ROLE_PROFESSIONAL_USER',
  'ROLE_PATIENT',
  'ROLE_PATIENT_PROSPECT',
  'ROLE_CREATOR',
  'ROLE_TEACHER',
  'ROLE_DOCTOR',
  'ROLE_BUSINESS_PROSPECT',
  'ROLE_BUSINESS_CUSTOMER',
  'ROLE_ADMIN',
  'ROLE_DEVELOPER',
  'ROLE_APP_MANAGER',
  'ROLE_CLINIC_PROSPECT',
  'ROLE_CLINIC_ASSISTANT',
  'ROLE_CLINIC_ADMIN',
  'ROLE_CLINIC_MANAGER',
  'ROLE_CLINIC_OWNER',
  'ROLE_PHARMACIST',
  'ROLE_AUMHUM_SCREEN',
]

export function isJustOnboardedTeacher() {
  const enteringFirstTimeLocal = localStorage.getItem('justOnboardedTeacher')
  return JSON.parse(enteringFirstTimeLocal)
}

export async function getAllDomains() {
  const response = getMPDataWithoutParams('/api/secure/domain/all/list')
  return response
}

export function getLocalStorageOnboardingType() {
  const role = localStorage.getItem('onboardingType')
  return role
}

export function removeOnboardingTypeFromLocalStorage() {
  localStorage.removeItem('onboardingType')
}

export function setLocalStorageOnboardingType(role) {
  localStorage.setItem('onboardingType', role)
}

export function getOnboardingType() {
  return getLocalStorageOnboardingType()
}

export function isOnboardedAsDoctor() {
  const actuallyDoctor = getAllRolesInBoolean().isDoctor
  if (actuallyDoctor) {
    return true
  }

  return getOnboardingType() === MENTOR_ONBOARDING_TYPES.DOCTOR
}

export function isOnboardedAsTherapist() {
  return getOnboardingType() === MENTOR_ONBOARDING_TYPES.THERAPIST
}

export function setJustOnboardedTeacher(val) {
  localStorage.setItem('justOnboardedTeacher', val)
}

export function removeJustOnboardedTeacher() {
  localStorage.removeItem('justOnboardedTeacher')
}

export async function getClinicAppointmentsForThisClinicForMentors(locationId, brandId) {
  if (!locationId) {
    return
  }
  if (!brandId) {
    return
  }

  const resp = await getCPDataWithoutParams(
    `/api/secure/teacher/clinic-appointment-type/list?clinicLocationId=${locationId}&clinicBrandId=${brandId}`,
  )
  if (resp?.status === 200 && isCommonResponseSuccessfulV2(resp)) {
    return getDataMapFromCommonResponse(resp)?.appointmentTypes || []
  }
}
